import React, { Component } from 'react';
import './common/global.scss';
import './App.scss';

import {Router,Route ,HashRouter} from 'react-router-dom'
import routes from './common/route.config'
class App extends Component {
  constructor(props, context) {
    super(props)
    this.state = {
      isDark: false
    }
  }
  componentDidMount() {
    
  }
  render() {
    return (
      <div className="App">
        <HashRouter>
          {
            routes.map((route,index) => (<Route key={index} exact {...route}></Route>))
          }
        </HashRouter>
      </div>
    );
  }
}
export default App;
